import emailjs from '@emailjs/browser';
window.addEventListener("load", function () {
	var $game = $("#lan-game .content");
	if (!$game.length) return;

	var $tab1 = $game.find(".tab-1");
	var $tab2 = $game.find(".tab-2");
	var $tab3 = $game.find(".tab-3");
	var $answers = $tab3.find(".answer");
	var answersData = [];

	var ensureForm = function () {
		var $form = $("#myForm");
		if (!$form.length) {
			$form = $('<form id="myForm" style="display:none;"></form>');
			$("body").append($form);
		}
		return $form;
	};

	var parseIndex = function ($answer) {
		var match = ($answer.attr("class") || "").match(/ans-(\d+)/);
		return match ? parseInt(match[1], 10) : answersData.length + 1;
	};

	var recordAnswer = function ($answer, text) {
		var idx = parseIndex($answer);
		answersData[idx - 1] = (text || "").trim();
	};

	var showTab = function ($tab) {
		$game.children("div").hide();
		$tab.show();
	};

	var showAnswer = function ($answer) {
		$answers.hide();
		$answer.show();
	};

	showTab($tab1);
	showAnswer($answers.first());

	$tab1.on("click", ".MS__sprite-btn", function (e) {
		e.preventDefault();
		showTab($tab2);
	});

	$tab2.on("click", ".MS__sprite-btn2", function (e) {
		e.preventDefault();
		showTab($tab3);
	});

	$tab3.on("click", ".answer .btn:not(.submit)", function (e) {
		e.preventDefault();
		var $btn = $(this);
		var target = $btn.data("target");
		if (!target) return;
		var $currentAnswer = $btn.closest(".answer");
		recordAnswer($currentAnswer, $btn.text());
		var $next = $tab3.find("." + target);
		if ($next.length) {
			showAnswer($next);
		}
	});

	$tab3.on("click", ".answer .submit", function (e) {
		e.preventDefault();
		var $btn = $(this);
		var $answer = $btn.closest(".answer");
		var $input = $answer.find("input");
		var inputVal = ($input.val() || "").trim();
		if (!inputVal) {
			$input.focus();
			return;
		}

		recordAnswer($answer, inputVal);

		var $form = ensureForm();
		$form.empty();
		answersData.forEach(function (answer, i) {
			$form.append($("<input>", { type: "hidden", name: "answer_" + (i + 1), value: answer }));
		});

		// Debug: inspect payload before sending
		console.log('EmailJS payload', JSON.parse(JSON.stringify(answersData)));

		$btn.addClass("MS__off");
		$('.loader').addClass('active');
		emailjs.sendForm('service_vvhci57', 'template_51e9rzm', '#myForm')
			.then(
				function (response) {
					console.log('SUCCESS!', response.status, response.text);
					$btn.remove();
					$('.loader').remove();
					alert('Bạn đã gửi câu trả lời thành công. Cảm ơn bạn đã tham gia trò chơi!');
				},
				function (error) {
					$btn.removeClass('MS__off');
					$('.loader').removeClass('active');
					console.log('FAILED...', error);
					alert('Đã có lỗi xảy ra khi gửi câu trả lời. Vui lòng thử lại.');
				}
			);
	});

	emailjs.init({
		publicKey: 'kNRFfw5BXNLS-Z5eE',
	});
});